import { CharactersList } from '@/components/Characters';

interface CharactersTabProps {
    hexId: number;
    isOwner: boolean;
    hasClaimedHex: boolean;
    isGm?: boolean;
}

export function CharactersTab({ hexId, isOwner, hasClaimedHex, isGm = false }: CharactersTabProps) {
    return (
        <div className="max-w-5xl">
            {/* Title with decorative styling */}
            <div className="flex items-center gap-3 mb-6">
                <div className="h-px flex-1 bg-gradient-to-r from-transparent via-amber-600/30 to-transparent" />
                <h2 className="text-3xl font-serif font-bold text-amber-100 tracking-wide">
                    Character Roster
                </h2>
                <div className="h-px flex-1 bg-gradient-to-r from-transparent via-amber-600/30 to-transparent" />
            </div>
            <CharactersList
                hexId={hexId}
                isOwner={isOwner}
                hasClaimedHex={hasClaimedHex}
                isGm={isGm}
            />
        </div>
    );
}
